import { useCallback } from 'react';
import { useCurrentLanguage } from 'tradera/lang/translate';
import { formatPrice, type Price } from 'tradera/localization/format-price';
import { useAppSelector } from 'tradera/state/hooks';
import { selectPreferredCurrency } from 'tradera/state/multi-currency/selectors';
import { isNullOrUndefined } from 'tradera/utils/condition-check';

type UseSekPriceFormatterOptions = {
    showSymbol?: boolean;
    decimals?: number;
    onlyShowValid?: boolean;
};

export const useSekPriceFormatter = ({
    showSymbol = true,
    decimals,
    onlyShowValid = false
}: UseSekPriceFormatterOptions = {}) => {
    const { language } = useCurrentLanguage();
    const preferredCurrency = useAppSelector(selectPreferredCurrency);

    return useCallback(
        (price: Price) => {
            if (
                onlyShowValid &&
                (isNullOrUndefined(price) || Number.isNaN(price))
            ) {
                return '';
            }

            return formatPrice(price, language, {
                preferredCurrency: preferredCurrency.code,
                ...(!showSymbol && { style: 'decimal' }),
                ...(decimals && {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals
                })
            });
        },
        [decimals, language, preferredCurrency.code, showSymbol, onlyShowValid]
    );
};
